export enum EI_FORM_NAMES {
  ROLE_NAMES = 'roleNames',
  FROM_MONTH = 'fromMonth',
  FROM_YEAR = 'fromYear',
  TO_MONTH = 'toMonth',
  TO_YEAR = 'toYear',
  CURRENTLY_EMPLOYED = 'currentlyEmployed'
}
